import { getMuiTheme } from './theme-items';
const muiBankTheme = getMuiTheme('bank');
export { muiBankTheme, getMuiTheme };
export * from './types';
//# sourceMappingURL=index.js.map